import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useReorderPerkMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.reorderTierPerks,
  {
    mutationKey: ['reorderPerk'],
  },
)
